import { useMutation, useQueryCache } from 'react-query';
import { removeZones } from 'src/services/api/users';

function useRemoveZones() {
  const queryCache = useQueryCache();

  return useMutation(({ user, data }) => removeZones(user, data), {
    onSuccess: (data) => queryCache.setQueryData(['user', data.data?.id], data),
  });
}

export default useRemoveZones;
